import { render, staticRenderFns } from "./tiaolimenu.vue?vue&type=template&id=318380c6&scoped=true&"
import script from "./tiaolimenu.vue?vue&type=script&lang=js&"
export * from "./tiaolimenu.vue?vue&type=script&lang=js&"
import style0 from "./tiaolimenu.vue?vue&type=style&index=0&id=318380c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318380c6",
  null
  
)

export default component.exports